import axios from 'axios'
/*
** rest : axios object with user auth headers
--------------------------------------------
** clear() : erase all auth data from session
---------------------------------------------
** logged() : verify if user is logged in session
**** @return boolean
---------------------------------------------
** login(#params) : log user
**** #params object : role with email and password { role: { email: 'a@a.com', password: '****' } }
**** @return promise
****** THEN: resolve(response) : user is logged
****** THEN: reject(error) : user is not authorized
****** CATCH: function(error) : error with server
---------------------------------------------
** logout() : delete user session
**** @return promise
****** THEN: resolve(response) : user signout sucessfully
****** CATCH: function(error) : error with server
---------------------------------------------
*/

export default {
  base_url: process.env.VUE_APP_API_BASE_URL,
  rest: null,
  adblocker: false,
  environment: process.env.NODE_ENV,
  axios: axios,
  get (url, params) {
    let parameters = []
    for (const k in params) {
      parameters.push(String(k) + '=' + String(params[k]))
    }
    // if (parameters.length > 0) {
    //   url += '?' + parameters.join('&')
    // }

    return this.rest.get(url)
  }
}
